// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { Cart } from "@insite/client-framework/Services/CartService";
import translate from "@insite/client-framework/Translate";
import { BillToModel } from "@insite/client-framework/Types/ApiModels";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { FC, useState } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import { infoProps } from "@store/Themes/common/props/info";
import { orderProps } from "@store/Themes/common/props/order";
/* Starter Custom Code - End */

interface OwnProps {
    cart: Cart;
    billTo: BillToModel;
    extendedStyles?: OrderConfirmationBillingInformationStyles;
}

export interface OrderConfirmationBillingInformationStyles {
    billingInformationGridContainer?: GridContainerProps;
    billingInformationTitleGridItem?: GridItemProps;
    billingInformationTitle?: TypographyProps;
    billingInformationBillingAddressGridItem?: GridItemProps;
    billingAddressTitle?: TypographyProps; // Starter Custom Code
    billingAddress?: AddressInfoDisplayStyles;
    billingInformationCreditCardAddressGridItem?: GridItemProps;
    billingCreditCardAddressTitle?: TypographyProps;
    creditCardBillingAddress?: AddressInfoDisplayStyles;
}

export const orderConfirmationBillingInformationStyles: OrderConfirmationBillingInformationStyles = {
    billingInformationGridContainer: infoProps.grid?.container,
    billingInformationTitle: orderProps.subtitle,
    billingInformationBillingAddressGridItem: infoProps.grid?.item,
    billingAddressTitle: infoProps.label,
    billingInformationCreditCardAddressGridItem: infoProps.grid?.item,
    billingCreditCardAddressTitle: infoProps.label,
};

type Props = OwnProps;

const OrderConfirmationBillingInformation: FC<Props> = ({ cart, extendedStyles, billTo }) => {
    const [styles] = useState(() => mergeToNew(orderConfirmationBillingInformationStyles, extendedStyles));

    return (
        <>
            {/* Starter Custom Code - Start */}
            <Typography {...styles.billingInformationTitle}>{translate("Billing Information")}</Typography>
            {/* Starter Custom Code - End */}
            <GridContainer {...styles.billingInformationGridContainer}>
                {/* Starter Moved - billingInformationTitle - before grid */}
                <GridItem
                    {...styles.billingInformationBillingAddressGridItem}
                    data-test-selector="orderConfirmationBillingInformation"
                >
                    <Typography {...styles.billingAddressTitle}>{translate("Billing Address")}</Typography>
                    <AddressInfoDisplay
                        companyName={billTo.companyName}
                        address1={billTo.address1}
                        address2={billTo.address2}
                        address3={billTo.address3}
                        address4={billTo.address4}
                        city={billTo.city}
                        postalCode={billTo.postalCode}
                        state={billTo.state ? billTo.state.abbreviation : undefined}
                        extendedStyles={styles.billingAddress}
                    />
                </GridItem>
                {cart.creditCardBillingAddress && (
                    <GridItem
                        {...styles.billingInformationCreditCardAddressGridItem}
                        data-test-selector="creditCardBillingAddress"
                    >
                        <Typography {...styles.billingCreditCardAddressTitle}>
                            {translate("Credit Card Address")}
                        </Typography>
                        <AddressInfoDisplay
                            address1={cart.creditCardBillingAddress.address1}
                            address2={cart.creditCardBillingAddress.address2}
                            city={cart.creditCardBillingAddress.city}
                            postalCode={cart.creditCardBillingAddress.postalCode}
                            state={cart.creditCardBillingAddress.stateAbbreviation}
                            extendedStyles={styles.creditCardBillingAddress}
                        />
                    </GridItem>
                )}
            </GridContainer>
        </>
    );
};

export default OrderConfirmationBillingInformation;
